import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  CircularProgress,
} from "@material-ui/core";
import { useTranslation } from "localization/translation";
import Select from "components/select";

const AddFeaturesModal = ({
  title,
  accept,
  close,
  isOpen,
  loading,
  features,
  selectedFeatureId,
  handleFeatureChange,
  errors,
}) => {
  const translation = useTranslation();
  
  return (
    <Dialog
      classes={{
        paper: `modal-content rounded-lg`,
      }}
      open={isOpen}
      onClose={close}
      aria-labelledby="form-dialog-title"
    >
      <form onSubmit={accept}>
        <DialogTitle className="px-4">{title}</DialogTitle>
        <div className="px-4">
          <div className="my-3 w-full">
            <Select
              onChange={(val) => {                
                handleFeatureChange(val)
              }}
              value={selectedFeatureId}
              field={"name_en"}
              label={translation.feature}
              noCard
              options={features}
              className="w-full"
              error={ errors?.feature || null }
            />
            {
              errors?.feature && (
                <span className="text-red">{errors?.feature}</span>
              )
            }
          </div>
        </div>
        <DialogActions className="d-flex mx-auto p-4">
          <Button
            onClick={close}
            variant="contained"
            type="button"
            className=""
          >
            {translation.no}
          </Button>
          <Button
            color="secondary"
            type="submit"
            variant="contained"
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : translation.yes}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddFeaturesModal;
